import { render, staticRenderFns } from "./BananaListEntry.vue?vue&type=template&id=bdf4be8a&scoped=true"
import script from "./BananaListEntry.vue?vue&type=script&lang=js"
export * from "./BananaListEntry.vue?vue&type=script&lang=js"
import style0 from "./BananaListEntry.vue?vue&type=style&index=0&id=bdf4be8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf4be8a",
  null
  
)

export default component.exports